import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutModal = ({ isOpen, handleClose }: Props) => {
  const cardClass = "block p-2 text-center border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
  const currentCardClass = "block p-2 text-center border border-green-500 rounded-lg bg-green-100 font-bold"

  return (
    <BaseModal title="About" isOpen={isOpen} handleClose={handleClose}>
      <div className="text-sm text-gray-500">
        <p className="mb-3">이 게임은 한글 Wordle를 하루종일 하고 싶은 분들을 위한 변형판입니다</p>

        <div className="grid grid-cols-3 gap-2 mb-2">
          <a href="https://w5.azki.org" className={currentCardClass}>
            한글 5자
          </a>
          <a href="https://w6.azki.org" className={cardClass}>
            한글 6자
          </a>
          <a href="https://w7.azki.org" className={cardClass}>
            한글 7자
          </a>
        </div>

        <div className="grid grid-cols-2 gap-2 mb-4">
          <a href="https://bw5.azki.org" className={cardClass}>
            협동워들 5자
          </a>
          <a href="https://bw6.azki.org" className={cardClass}>
            협동워들 6자
          </a>
        </div>

        <p className="mb-3">이 게임을 차르디님께 바칩니다.</p>

        <a href="https://www.nytimes.com/games/wordle/index.html" target="_blank" rel="noreferrer noopener"
          className="underline font-bold">
          오리지널은 여기에서
        </a>
      </div>
    </BaseModal>
  )
}
